import React, { createContext, useEffect, useState } from 'react';
import {
  REGISTER_SESSION_EVENT, adoptStoredRegisterSession, confirmRegisterSwitch,
  currentRegisterToken,
} from './utils/registerSession';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [sessionToken, setSessionToken] = useState(currentRegisterToken);
  const [sessionChanged, setSessionChanged] = useState(false);

  useEffect(() => {
    const changedHere = () => {
      setSessionToken(currentRegisterToken());
      setUser(null);
      setSessionChanged(false);
    };
    const changedElsewhere = event => {
      if (event && event.key !== null && event.key !== 'token') return;
      // Preserve mounted drafts until the user chooses to leave this workspace.
      setSessionChanged(localStorage.getItem('token') !== currentRegisterToken());
    };
    window.addEventListener(REGISTER_SESSION_EVENT, changedHere);
    window.addEventListener('storage', changedElsewhere);
    const focused = () => changedElsewhere();
    window.addEventListener('focus', focused);
    focused();
    return () => {
      window.removeEventListener(REGISTER_SESSION_EVENT, changedHere);
      window.removeEventListener('storage', changedElsewhere);
      window.removeEventListener('focus', focused);
    };
  }, []);

  const resumeSession = () => {
    if (confirmRegisterSwitch()) adoptStoredRegisterSession();
  };
  return <UserContext.Provider value={{ user, setUser, sessionToken, sessionChanged, resumeSession }}>
    {children}
  </UserContext.Provider>;
};
